import React, { useState } from "react";

const ReadMore = ({ children }) => {
  const text = children;
  const [isReadMore, setIsReadMore] = useState(true);
  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  return (
    <>
      <p className="text text-lg text-gray-900">
        {isReadMore ? text.slice(0, 400) : text}
        <span
          onClick={toggleReadMore}
          className="text-red-600 dark:text-green-600 cursor-pointer"
        >
          {isReadMore ? " ...read more" : " ...show less"}
        </span>
      </p>
    </>
  );
};

export default ReadMore;
